<script>
const isYoutube = (url) => /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/gm.test(url);
export default {
    props: {
        quotes: {type: Array, default: []},
        media: {type: Array, default: []}
    },
    data: () => ({
        videos: [],
        content: []
    }),
    computed: {
        testimonials() {
            const result = [];
            const videoLen = this.videos.length;
            const contentLen = this.content.length;
            const spacing = Math.floor(videoLen > contentLen ? videoLen / contentLen : contentLen / videoLen);
            let index = 0;
            if (videoLen > contentLen) {
                this.videos.forEach((val, i) => {
                    if (i % spacing === 0 && this.content[index]) {
                        result.push(this.content[index]);
                        index++;
                    }
                    result.push(val);
                });
            } else {
                this.content.forEach((val, i) => {
                    if (i !== 0 && i % spacing === 0 && this.videos[index]) {
                        result.push(this.videos[index]);
                        index++;
                    }
                    result.push(val);
                });
            }
            return result;
        }
    },
    created() {
        this.pullVideos();
    },
    methods: {
        pullVideos() {
            this.quotes.forEach((item) => {
                if (item.video_url) {
                    this.videos.push({
                        type: 'video',
                        video: item.video_url,
                        thumbnail: item.resourceImage || this.getThumbnail(item.video_url, 'hqdefault'),
                        cite: item.name,
                        hasImage: !!item.resourceImage
                    });
                } else {
                    this.content.push({
                        type: 'text',
                        title: item.title,
                        quote: item.description,
                        thumbnail: item.resourceImage || this.getThumbnail(item.video_url, 'hqdefault'),
                        cite: item.name,
                        hasImage: !!item.resourceImage
                    });
                }
            });
        },

        /**
         * By default, will return default quality thumbnail
         *
         * Default quality - 'default'
         * High quality - 'hqdefault'
         * Medium quality - 'mqdefault'
         * Standard def quality - 'sddefault'
         * Max resolution - 'maxresdefault'
         *
         * @param {String} url - The video url
         * @param {String} [quality = 'default'] - Quality (optional)
         */
        getThumbnail(url, quality = 'default') {
            let thumbnail = 'images/site/not_found.jpg';

            if (isYoutube(url)) {
                const query = url.split('?')[1].split('#')[0].split('&');
                const params = {};

                query.forEach((val, key) => {
                    const parts = val.split('=', 2);
                    params[parts[0]] = parts[1];
                });

                thumbnail = `//img.youtube.com/vi/${params.v}/${quality}.jpg`;
            }

           return thumbnail;
        }
    }
};
</script>
